<div class="modal-header">
    <img src="assets/img/auth_establishment/close-white.svg" (click)="bsModalRef.hide()">
</div>
<div class="modal-body">
    <img class="icon" src="{{iconSrc}}">
    <h2 class="my-5">{{title}}</h2>
    <p>{{description}}</p>
</div>
